module.exports = __webpack_public_path__ + "assets/icons/tricentis-logo.c6873ab04d9f6076d3093b8ecd60fc57.svg";